<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      persistent
      max-width="400"
    >
      <v-card>
        <v-card-title class="text-h5">
          تأكيد الإرسال
        </v-card-title>
        <v-card-text style="font-weight: bold; font-size: 16px;">
          هل أكلمت بيانات العميل وترغب في ارسال الطلب ؟
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red"
            depressed
            elevation="3"
            outlined
            small
            @click="cancel"
          >
            إلغاء
          </v-btn>
          <v-btn
            depressed
            elevation="3"
            small
            color="primary"
            @click="confirm"
          >
            نعم
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  name: 'SendRequestConfirmationDialog',

  props: {
    value: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },

  methods: {
    confirm() {
      this.$emit('confirm');
      this.dialog = false;
    },
    cancel() {
      this.dialog = false;
    }
  }
}
</script>
